import { Component, effect, inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PhitoTableSetting } from '../../../components/data-table/data-table';
import { DataTableService } from '../../../components/data-table/data-table.service';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'phito-favorite-menu-button',
    templateUrl: './favorite-menu-button.component.html',
    styleUrls: ['./favorite-menu-button.component.scss'],
    imports: [CommonModule, MatIconModule, MatButtonModule, MatMenuModule],
})
export class FavoriteMenuButtonComponent {
    private rtr = inject(Router);
    private tableService = inject(DataTableService);

    @Input() isMenuNameVisible = true;

    favorites: PhitoTableSetting[] = [];

    constructor() {
        effect(() => {
            this.tableService.tableSettingsChanged()
            this.loadFavorites();
        });
    }

    isActiveRoute() {
        let pathElements = '/favorites';
        return this.rtr.isActive(pathElements, {
            paths: 'subset',
            queryParams: 'subset',
            fragment: 'ignored',
            matrixParams: 'ignored',
        });
    }

    navigate(f: PhitoTableSetting) {
        this.rtr.navigate([f.url], { queryParams: { tableSettingId: f.id }, replaceUrl: true }).then();
    }

    private loadFavorites() {
        this.tableService.getUserFavorites().subscribe({
            next: (response) => {
                this.favorites = (<PhitoTableSetting[]>response?.data).filter(s => s.url);
            },
            error: (err) => {
                console.log(err);
            },
        });
    }
}
